import { EntTerritorialUnitsFilterPoligons } from "./territorialUnitsFilterPoligons";
import { EntTerritorialsUnitsPoligons } from "./territorialsUnitsPoligons";
import { ResponseDataGet } from "../../models/responseDataGet";
import { Paths } from "../../paths";
import { agroApi } from "../../redux/api/api"; 

export const territorialUnitPolygonsApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({
        getTerritorialUnitsPolygonsList: builder.query<
            ResponseDataGet<EntTerritorialsUnitsPoligons>,
            EntTerritorialUnitsFilterPoligons
        >({
            query: (filter) => ({
                url: `${ Paths.handbooks.territorialunits }/get-all/polygons`,
                method: "POST",
                body: {
                    page: filter.page,
                    size: filter.size,
                    type: filter.type
                },
            }),
            // staleTime: 1000 * 60 * 5, // 5 минут данные считаются актуальными
            // cacheTime: 1000 * 60 * 10, // 10 минут данные хранятся в кеше
        }),
    }),
    overrideExisting: false, 
});

export const { useGetTerritorialUnitsPolygonsListQuery } = territorialUnitPolygonsApi;

